export enum apiUrlSpecials {
    SPECIALS = '/v1/specials/',
}
